import { type InfiniteData, infiniteQueryOptions } from '@tanstack/react-query';
import type {
  ListDuosData,
  ListDuosResponse,
} from 'generated/openapi/types.gen';

import { PrivateApi } from '@/shared/api/httpClient';

export interface GetDuosQueryKeyParams {
  pageSize?: number;
}

export const DUOS_BASE_KEY = ['duos'] as const;

export const getDuosKey = ({ pageSize = 5 }: GetDuosQueryKeyParams = {}) =>
  [...DUOS_BASE_KEY, 'list', { pageSize }] as const;

export type GetDuosQueryKey = ReturnType<typeof getDuosKey>;

const getDuosUrl: ListDuosData['url'] = 'duos';

export const getDuosOptions = <T = InfiniteData<ListDuosResponse>>({
  pageSize = 10,
}: GetDuosQueryKeyParams = {}) =>
  infiniteQueryOptions<ListDuosResponse, unknown, T, GetDuosQueryKey, number>({
    queryKey: getDuosKey({ pageSize }),
    queryFn: ({ pageParam }) =>
      PrivateApi.get(getDuosUrl, {
        searchParams: {
          pageNumber: pageParam,
          pageSize,
        },
      }).json<ListDuosResponse>(),
    initialPageParam: 0,
    getNextPageParam: ({ page: { number, totalPages } }) => {
      const nextPage = number + 1;
      return nextPage < totalPages ? nextPage : undefined;
    },
  });
